import Layout from '@/layout'

const accountingRouter = {
  path: '/accounting',
  component: Layout,
  redirect: '/accounting/account',
  name: 'Nested',
  meta: {
    title: 'Kế toán'
    // icon: 'list'
  },
  children: [
    {
      path: 'account',
      name: 'Tài khoản',
      component: () => import('@/views/nested/menu1/index'),
      meta: {
        title: 'Tài khoản'
      },
      redirect: '/accounting/account/ar_account',
      children: [
        {
          path: 'ar_account',
          name: 'Tài khoản công nợ',
          meta: {
            title: 'Tài khoản công nợ'
          },
          component: () =>
            import('@/views/mci/accounting/account/arAccount.vue')
        },
        {
          path: 'get_from_fo',
          name: 'Nhận từ lễ tân',
          meta: {
            title: 'Nhận từ lễ tân'
          },
          component: () =>
            import('@/views/mci/accounting/account/getFromTo.vue')
        },
        {
          path: 'statement',
          name: 'Bảng kê công nợ',
          meta: {
            title: 'Bảng kê công nợ'
          },
          component: () =>
            import('@/views/mci/accounting/account/statement.vue')
        }
      ]
    },
    {
      path: 'cash_list',
      name: 'Bảng kê tiền mặt',
      meta: {
        title: 'Bảng kê tiền mặt'
      },
      component: () => import('@/views/mci/accounting/account/cashList.vue')
    },
    {
      path: 'agent_wallet',
      name: 'Theo dõi tiền nạp đại lý',
      meta: {
        title: 'Theo dõi tiền nạp đại lý'
      },
      component: () => import('@/views/mci/accounting/agentWallet/index.vue')
    }
  ]
}

export default accountingRouter
